export default {"src":"/_next/static/media/white-room-names.f4e4dbee.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};